import React from 'react';

export default function DueDate(props) {
	return (
		<div className="InvoiveDueDate md:mx-2 min-w-80 my-2 p-2">
			<h2 className="text-md">
				<strong>DUE DATE</strong>
			</h2>
			<span className="text-md">Nov 1st, 2023</span>
		</div>
	);
}
